import React, { MouseEventHandler, useEffect, useState } from "react";

import cn from "classnames";
import { useTranslation } from "react-i18next";

import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import { message, Tooltip } from "antd";

import { Deeplink } from "../../store/common_types";

import styles from "./styles.module.scss";

export interface DeeplinkProps {
  className?: string;
  deeplink: Deeplink;
  visibleTooltip?: boolean;
  onDeeplinkClick?: (deeplink: Deeplink) => void;
}

export const DeeplinkComponent: React.FC<DeeplinkProps> = (props) => {
  const { t } = useTranslation("deeplink");

  const [copied, setCopied] = useState(false);
  const [visibleTooltip, setVisibleTooltip] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => setCopied(false), 1250);
    }
  }, [copied]);

  const handleLinkClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (props.onDeeplinkClick) {
      props.onDeeplinkClick(props.deeplink);
      event.preventDefault();
    }
  };

  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(props.deeplink.url)
      .then(() => setCopied(true))
      .then(async () => message.success(t("clipboard.success")))
      .catch(async () => message.warning(t("clipboard.error")));
  };

  const handleChangeVisible = (value: boolean) => {
    if (props.visibleTooltip === undefined || props.visibleTooltip) {
      setVisibleTooltip(value);
    }
  };

  return (
    <div className={cn([styles.deeplinkUrl, props.className])}>
      <a href={props.deeplink.url} target="_blank" rel="noreferrer" onClick={handleLinkClick}>
        {props.deeplink.url}
      </a>
      <Tooltip title={t("clipboard.tooltip")} visible={visibleTooltip} onVisibleChange={handleChangeVisible}>
        {copied ? <CheckOutlined /> : <CopyOutlined onClick={handleCopyClick} />}
      </Tooltip>
    </div>
  );
};
